import { useCallback } from "react";

export function useRipple() {
  const createRipple = useCallback((e) => {
    const button = e.currentTarget;
    if (button.disabled) return;

    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 2;
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    const ripple = document.createElement("span");
    ripple.className = "ripple";
    // Layout-critical styles are inline, not left to the scoped .ripple CSS
    // rules: the span is sized to 2× its host (thousands of px on a wide
    // card/row), so on any surface missing a scoped rule an in-flow span
    // that big joins the host's flex/grid layout and blows it open. Scoped
    // CSS still supplies the visuals (background, ripple-expand animation).
    ripple.style.position = "absolute";
    ripple.style.borderRadius = "50%";
    ripple.style.pointerEvents = "none";
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;

    button.appendChild(ripple);
    ripple.addEventListener("animationend", () => ripple.remove());
    // Fallback reaper: without a scoped animation rule, animationend never
    // fires — don't let unremoved spans accumulate on every click.
    setTimeout(() => ripple.remove(), 700);
  }, []);

  return createRipple;
}
